import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder_key';

// In development mode with placeholders, create a mock client
const isPlaceholder = supabaseUrl.includes('placeholder') || supabaseAnonKey === 'placeholder_key';

if (isPlaceholder && import.meta.env.DEV) {
  console.warn('🚧 Using Supabase placeholder configuration for development. Authentication features will be limited.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);